import { init, trackEvent} from '@aptabase/web';

init('A-SH-8192575251', {host: 'https://mproxy.godcaster.app', isDebug: false, appVersion: '1.0s'});

window.metricsEvent = trackEvent;
